import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as unsubscribeActions from "../action/unsubscribe.action";
import {catchError, exhaustMap} from "rxjs/operators";
import {map, of} from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import {UnsubscribeService} from "../service/unsubscribe.service";


@Injectable()
export class UnsubscribeEffect {


  blog$ = createEffect(() => this
    .actions$
    .pipe(ofType(unsubscribeActions.unsubscribe),
      exhaustMap(({resource}) => this
        .unsubscribeService
        .unsubscribe(resource)
        .pipe(map(() => unsubscribeActions.unsubscribeSuccess()),
          catchError((httpErrorResponse: HttpErrorResponse) =>
            of(unsubscribeActions.unsubscribeFailure(({error: httpErrorResponse.error}))))))))

  constructor(private actions$: Actions, private unsubscribeService: UnsubscribeService) {
  }
}
